import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Image from "../images/logo.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 100) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  });

  const Item = ({ path, text }) => {
    const location = useLocation();
    const buttonClass = location.pathname === path ? "underline" : "";

    return (
      <Link
        className={`${buttonClass} drop-shadow-md p-4 font-semibold text-white uppercase decoration-2 underline-offset-8 hover:underline`}
        to={path}
      >
        {text}
      </Link>
    );
  };

  return (
    <nav
      className={`w-full fixed top-0 z-30 px-4 py-4 transition-colors ease-in duration-700 ${
        scrolled ? `bg-neutral-700` : `bg-transparent`
      }`}
    >
      <div className="flex gap-10 justify-center items-center font-oswald">
        <Item text="Sobre nós" path="/about" />
        <Item text="Cozinhas" path="/kitchens" />
        <Link to="/">
          <img src={Image} alt="" className="w-80 drop-shadow-md" />
        </Link>
        <Item text="Roupeiros" path="/closets" />
        <Item text="Contactos" path="/contacts" />
      </div>
    </nav>
  );
};

export default Navbar;
